(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shop-the-look-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('look-product-list')) {
    customElements.define('look-product-list', class extends HTMLElement {
      static cartQueue = Promise.resolve();

      connectedCallback() {
        this.initGalleries();
        this.initSizeSelectors();
        this.initAlignment();

        if (this.lookInitialized) return;
        this.lookInitialized = true;

        this.addEventListener('change', (event) => {
          const target = event.target;

          if (
            target instanceof HTMLSelectElement &&
            target.matches('[data-size-dropdown]')
          ) {
            const input = Array.from(
              target.form.querySelectorAll('input[data-price]')
            ).find((radio) => {
              return radio.value === target.value && !radio.disabled;
            });

            if (!input) return;

            input.checked = true;
            this.updateSizeSelection(input);
            return;
          }

          if (
            target instanceof HTMLInputElement &&
            target.matches('input[data-price]')
          ) {
            this.updateSizeSelection(target);
          }
        });

        this.addEventListener('click', (event) => {
          const arrow = event.target.closest('button[data-slide]');
          if (!arrow) return;

          const gallery = arrow.closest('.look-products__gallery');
          const track = gallery.querySelector('.look-products__track');
          const slider = gallery.querySelector('[data-gallery-progress]');

          if (!track.clientWidth) return;

          const count = Number(slider.max) + 1;
          const position = Math.round(track.scrollLeft / track.clientWidth);

          const next = Math.max(
            0,
            Math.min(count + 1, position + Number(arrow.dataset.slide))
          );

          track.scrollTo({
            left: next * track.clientWidth,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth'
          });
        });

        this.addEventListener('submit', (event) => {
          const form = event.target;

          if (
            !(form instanceof HTMLFormElement) ||
            !form.matches('.look-products__form')
          ) return;

          event.preventDefault();
          event.stopPropagation();

          if (form.dataset.busy || !form.reportValidity()) return;

          const button = form.querySelector('[name="add"]');

          form.dataset.busy = 'true';
          button.disabled = true;
          form.setAttribute('aria-busy', 'true');

          const task = () => this.addItem(form);

          this.constructor.cartQueue = this.constructor.cartQueue.then(
            task,
            task
          );
        });
      }

      disconnectedCallback() {
        this.galleryObserver?.disconnect();
        this.galleryObserver = null;

        this.alignmentObserver?.disconnect();
        this.alignmentObserver = null;

        this.sizeMedia?.removeEventListener(
          'change',
          this.sizeMediaHandler
        );

        this.querySelectorAll('.look-products__gallery').forEach((gallery) => {
          clearTimeout(gallery.loopTimer);
        });
      }

      updateSizeSelection(input) {
        const form = input.form;
        const select = form?.querySelector('[data-size-dropdown]');

        if (select) select.value = input.value;

        const price = input
          .closest('.look-products__item')
          ?.querySelector('[data-look-price]');

        if (price) price.textContent = input.dataset.price;

        const box = form?.querySelector('[data-preorder-box]');
        const text = box?.querySelector('[data-preorder-text]');
        const message = input.dataset.preorderText || '';

        if (box && text) {
          text.textContent = message;
          box.hidden = !message;
        }

        const error = form?.querySelector('.look-products__message');
        if (error) error.textContent = '';
      }

      initSizeSelectors() {
        this.sizeMedia?.removeEventListener(
          'change',
          this.sizeMediaHandler
        );

        this.sizeMedia = matchMedia('(max-width: 749px)');

        this.querySelectorAll('.look-products__form').forEach((form) => {
          const select = form.querySelector('[data-size-dropdown]');

          if (!select || select.dataset.initialized) return;

          select.dataset.initialized = 'true';

          form.querySelectorAll('input[data-price]').forEach((radio) => {
            const label = radio.labels?.[0]?.textContent
              .replace(/\s+/g, ' ')
              .trim() || radio.value;

            const option = document.createElement('option');

            option.value = radio.value;
            option.textContent = label;
            option.disabled = radio.disabled;

            select.append(option);
          });
        });

        this.sizeMediaHandler = () => this.syncSizeModes();

        this.sizeMedia.addEventListener(
          'change',
          this.sizeMediaHandler
        );

        this.syncSizeModes();
      }

      syncSizeModes() {
        const mobile = this.sizeMedia.matches;

        const enabled = (
          mobile
            ? this.dataset.dropdownMobile
            : this.dataset.dropdownDesktop
        ) === 'true';

        const threshold = Number(
          mobile
            ? this.dataset.dropdownThresholdMobile
            : this.dataset.dropdownThresholdDesktop
        );

        this.querySelectorAll('.look-products__form').forEach((form) => {
          const select = form.querySelector('[data-size-dropdown]');
          const buttons = form.querySelector('.look-products__size-options');

          const radios = Array.from(
            form.querySelectorAll('input[data-price]')
          );

          if (!select || !buttons) return;

          const useDropdown = enabled && radios.length > threshold;

          const selected = radios.find((radio) => {
            return radio.checked && !radio.disabled;
          });

          const active = document.activeElement;
          const focusWasOnButtons = buttons.contains(active);
          const focusWasOnSelect = active === select;

          buttons.hidden = useDropdown;
          select.hidden = !useDropdown;
          select.disabled = !useDropdown;
          select.required = useDropdown;

          radios.forEach((radio) => {
            radio.required = !useDropdown;
          });

          select.value = selected?.value || '';

          if (selected) this.updateSizeSelection(selected);

          if (useDropdown && focusWasOnButtons) {
            select.focus({ preventScroll: true });
          }

          if (!useDropdown && focusWasOnSelect) {
            const target = selected || radios.find((radio) => !radio.disabled);
            target?.focus({ preventScroll: true });
          }
        });
      }

      initAlignment() {
        this.alignmentObserver?.disconnect();

        const align = (item) => {
          const image = item.querySelector('.look-products__track');
          const core = item.querySelector('.look-products__core');
          const details = item.querySelector('.look-products__details');

          if (!image || !core || !details) return;

          const top = Math.max(
            0,
            (
              image.getBoundingClientRect().height -
              core.getBoundingClientRect().height
            ) / 2
          );

          details.style.setProperty('--look-details-offset', `${top}px`);
        };

        this.alignmentObserver = new ResizeObserver((entries) => {
          const items = new Set(
            entries.map((entry) => {
              return entry.target.closest('.look-products__item');
            })
          );

          items.forEach((item) => {
            if (item) align(item);
          });
        });

        this.querySelectorAll('.look-products__item').forEach((item) => {
          const image = item.querySelector('.look-products__track');
          const core = item.querySelector('.look-products__core');

          if (image) this.alignmentObserver.observe(image);
          if (core) this.alignmentObserver.observe(core);

          align(item);
        });
      }

      initGalleries() {
        this.galleryObserver?.disconnect();

        this.galleryObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const gallery = entry.target.closest('.look-products__gallery');
            const track = gallery.querySelector('.look-products__track');
            const slider = gallery.querySelector('[data-gallery-progress]');

            if (!slider || !track.clientWidth) continue;

            const count = Number(slider.max) + 1;

            slider.style.setProperty(
              '--look-thumb-width',
              `${slider.clientWidth / count}px`
            );

            track.scrollLeft =
              (Number(gallery.dataset.index || 0) + 1) * track.clientWidth;
          }
        });

        this.querySelectorAll('.look-products__gallery').forEach((gallery) => {
          const track = gallery.querySelector('.look-products__track');
          const slider = gallery.querySelector('[data-gallery-progress]');

          if (!slider) return;

          if (!gallery.dataset.initialized) {
            gallery.dataset.initialized = 'true';
            gallery.dataset.index = '0';

            const images = Array.from(
              track.querySelectorAll('.look-products__image')
            );

            images.forEach((image) => {
              image.classList.remove('look-products__image--last');
            });

            const start = Math.min(
              Math.max(0, Number(gallery.dataset.firstImage || 0)),
              images.length - 1
            );

            images.slice(0, start).forEach((image) => track.append(image));

            const orderedImages = Array.from(
              track.querySelectorAll('.look-products__image')
            );

            const firstClone = orderedImages[0].cloneNode(true);

            const lastClone = orderedImages[orderedImages.length - 1]
              .cloneNode(true);

            for (const clone of [firstClone, lastClone]) {
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('tabindex', '-1');
            }

            track.prepend(lastClone);
            track.append(firstClone);

            const count = orderedImages.length;

            const normalizeLoop = () => {
              if (!track.clientWidth) return;

              const position = Math.round(
                track.scrollLeft / track.clientWidth
              );

              if (
                Math.abs(track.scrollLeft - position * track.clientWidth) > 2
              ) return;

              if (position === 0) {
                track.scrollLeft = count * track.clientWidth;
              }

              if (position === count + 1) {
                track.scrollLeft = track.clientWidth;
              }
            };

            track.addEventListener('scroll', () => {
              if (!track.clientWidth) return;

              const position = Math.round(
                track.scrollLeft / track.clientWidth
              );

              const index = ((position - 1) % count + count) % count;

              gallery.dataset.index = String(index);
              slider.value = String(index);

              clearTimeout(gallery.loopTimer);
              gallery.loopTimer = setTimeout(normalizeLoop, 160);
            }, { passive: true });

            track.addEventListener('scrollend', normalizeLoop);

            slider.addEventListener('input', () => {
              clearTimeout(gallery.loopTimer);
              gallery.dataset.index = slider.value;

              track.scrollTo({
                left: (Number(slider.value) + 1) * track.clientWidth,
                behavior: 'auto'
              });
            });
          }

          this.galleryObserver.observe(track);
          this.galleryObserver.observe(slider);
        });
      }

      async addItem(form) {
        const button = form.querySelector('[name="add"]');
        const message = form.querySelector('.look-products__message');
        let added = false;

        message.textContent = '';

        try {
          const drawer = document.querySelector('cart-drawer-component');

          const sectionId = drawer
            ?.querySelector('cart-items-component[data-section-id]')
            ?.dataset.sectionId;

          if (!drawer || !sectionId) {
            throw new Error('Cart drawer unavailable');
          }

          const body = new FormData(form);

          body.set('sections', sectionId);
          body.set('sections_url', window.location.pathname);

          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            body,
            headers: { Accept: 'application/json' }
          });

          const result = await response.json();

          if (!response.ok || result.status) {
            message.textContent = typeof result.description === 'string'
              ? result.description
              : this.dataset.error;
            return;
          }

          added = true;

          const html = result.sections?.[sectionId];

          if (!html) {
            throw new Error('Cart rendering unavailable');
          }

          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newDrawer = parsed.querySelector('cart-drawer-component');

          if (!newDrawer) {
            throw new Error('Cart drawer missing');
          }

          await customElements.whenDefined('cart-drawer-component');

          drawer.replaceWith(newDrawer);

          await new Promise(requestAnimationFrame);

          const trigger = newDrawer.querySelector(
            '[data-testid="cart-drawer-trigger"]'
          );

          if (!trigger) {
            throw new Error('Cart trigger missing');
          }

          trigger.click();
        } catch (error) {
          message.textContent = added
            ? this.dataset.refreshError
            : this.dataset.error;
        } finally {
          delete form.dataset.busy;
          form.removeAttribute('aria-busy');
          button.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
